<template>
	<v-form @submit.prevent="onSubmit">
		<row row wrap>
			<v-col cols="12">
				<v-text-field
					v-model="form.gameInstructions"
					label="הוראות המשחק"
					required
				></v-text-field>
			</v-col>
			<v-col cols="12">
				<v-text-field
					v-model="form.finishText"
					label=" טקסט סיום"
					required
				></v-text-field>
			</v-col>
			<v-col cols="12">
				<v-text-field
					v-model="form.titleView"
					label="כותרת המשחק"
					required
				></v-text-field>
			</v-col>
			<v-col cols="12">
				<v-text-field
					v-model="form.gameTitle"
					label="שם המשחק"
					required
				></v-text-field>
			</v-col>
			<v-col cols="12">
				<label>צבע רקע:</label>
				<input type="color" v-model="form.backgroundColor" />
			</v-col>

			<v-col cols="4" class="mt-3">
				<label>תמונת רקע:</label>
			</v-col>
			<v-col cols="4">
				<v-img
					v-if="form.backgroundImage"
					:src="form.backgroundImage"
					width="60%"
					max-height="60%"
				></v-img>
				<relation-media-modal
					v-model="mediaDialog"
					@close="mediaDialog = false"
					:fileFilter="['image']"
					@mediaSelected="mediaSelected"
					:selectedMedia="form.backgroundImage"
				/>
			</v-col>
			<v-col cols="4">
				<v-btn small color="#ffc90d " @click="mediaDialog = true">
					<v-icon>fas fa-video</v-icon>
					בחר תמונה
				</v-btn>
			</v-col>
		</row>

		<v-spacer> </v-spacer>
		<!-- <save-btn/> -->
		<div class="form-group mt-2">
			<v-btn :loading="inProgress" type="submit" color="success">
				שמירה
			</v-btn>
		</div>
	</v-form>
</template>

<script>
// import RelationMediaModal from "dev/view/media/RelationMediaModal";

export default {
	name: "game-more-settings-form",
	props: [],
	components: {
		// RelationMediaModal
	},
	data() {
		return {
			form: {
				gameInstructions: "",
				finishText: "",
				titleView: "",
				gameTitle: "",
				backgroundImage: "",
				backgroundColor: ""
			},
			mediaDialog: false
		};
	},
	computed: {
		json() {
			return JSON.parse(this.$store.state.GameModule.game.json);
		}
	},
	methods: {
		initSettings() {
			this.form.gameInstructions = this.json.setting.popup.openPopup.label.text;
			this.form.finishText = this.json.setting.popup.finishPopup.label.text[0];
			this.form.titleView = this.json.setting.TitleView.text;
			this.form.gameTitle = this.json.setting.gameTitle;
			this.form.backgroundColor = this.json.setting.backgroungColor;
			this.form.backgroundImage = this.json.setting.backgroungImage;
		},
		mediaSelected(value) {
			this.form.backgroundImage = value.link;
		},
		onSubmit() {
			let json = this.json;
			json.setting.popup.openPopup.label.text = this.form.gameInstructions;
			json.setting.popup.finishPopup.label.text[0] = this.form.finishText;
			json.setting.TitleView.text = this.form.titleView;
			json.setting.gameTitle = this.form.gameTitle;
			json.setting.backgroungColor = this.form.backgroundColor;
			json.setting.backgroungImage = this.form.backgroundImage;
			this.$emit("save", { json: json, refreshPage: true });
			this.$emit("close");
		}
	},
	created() {
		this.initSettings();
	},
	mounted() {},
	updated() {},
	destroyed() {}
};
</script>

<style scoped></style>
